// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RadioGroup, Radio } from 'informed';

import {
  addSyphilisTest,
  deleteSyphilisTest,
  updateSyphilisTest,
} from '../../../actions/testingActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';

type Props = {
  syphilisTests: Object[],
  activePatientId: string,
  addSyphilisTest: Function,
  deleteSyphilisTest: Function,
  updateSyphilisTest: Function,
}

class SyphilisTestsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteSyphilisTest(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateSyphilisTest(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addSyphilisTest(this.props.activePatientId, formData.values);
  }

  render() {
    let { syphilisTests } = this.props;
    syphilisTests = syphilisTests.map((item, index) => ({ testNum: syphilisTests.length - index, ...item }));

    const columns = [
      {
        Header: '',
        id: 'index',
        cell: item => `Test #${item.testNum ? item.testNum : ''}`,
        width: 80,
      },
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
      },
      {
        Header: 'Type',
        id: 'type',
        cell: () => 'Blood',
      },
      {
        Header: 'Result',
        id: 'positive',
        editCell: item => (
          <RadioGroup field='positive' initialValue={item.positive}>
            <Radio value={'Positive'} />Positive
            <br />
            <Radio value={'Negative'} />Negative
            <br />
            <Radio value={'Unknown'} />Unknown
          </RadioGroup>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        data={syphilisTests}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  syphilisTests: state.patient.data.testing.syphilisTests,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addSyphilisTest:
    (patientId, syphilisTest) => dispatch(addSyphilisTest(patientId, syphilisTest)),
  deleteSyphilisTest:
    (patientId, syphilisTestId) => dispatch(deleteSyphilisTest(patientId, syphilisTestId)),
  updateSyphilisTest:
    (patientId, syphilisTest) => dispatch(updateSyphilisTest(patientId, syphilisTest)),
});

const SyphilisTests = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SyphilisTestsComponent);

export default SyphilisTests;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/SyphilisTests.jsx